/* eslint-disable no-useless-escape */
// RegEx
export const ONLY_NUMBER = /^[0-9]*$/
export const EMAIL =
  /^\s*(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))\s*$/
export const PASSWORD = /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-])/
export const NO_SPACE = /^\S*$/
export const NO_SPECIAL_CHARACTER = /^[A-Za-z0-9 ]+$/
export const NUMBER1TO10 = /^[1-9][0-9]?$|^100$/
export const URL_REGEX =
  /(([\w]+:)?\/\/)?(([\d\w]|%[a-fA-f\d]{2,2})+(:([\d\w]|%[a-fA-f\d]{2,2})+)?@)?([\d\w][-\d\w]{0,253}[\d\w]\.)+[\w]{2,63}(:[\d]+)?(\/([-+_~.\d\w]|%[a-fA-f\d]{2,2})*)*(\?(&?([-+_~.\d\w]|%[a-fA-f\d]{2,2})=?)*)?(#([-+_~.\d\w]|%[a-fA-f\d]{2,2})*)?/
export const CHECK_AMP = /^.*(\?|\&)amp(|\=)(|\&.*)$/

export const S3_PREFIX = process.env.REACT_APP_S3_PREFIX || 'https://media.cricketbazaar.com/'
export const GRAPHQL_URL = process.env.REACT_APP_API_URL || 'https://gateway.api.cricketbazaar.com/graphql'
// export const GRAPHQL_INTERNAL_URL =
// 	process.env.NODE_ENV === 'development'
// 		? GRAPHQL_URL
// 		: process.env.REACT_APP_INTERNAL_API_URL ||
// 		  'http://sb-backend-gateway-production-internal.production.svc.cluster.local/graphql' ||
// 		  GRAPHQL_URL
export const GRAPHQL_INTERNAL_URL = GRAPHQL_URL
export const SUBSCRIPTION_URL = process.env.REACT_APP_SUBSCRIPTION_URL || 'wss://subscription.api.cricketbazaar.com/graphql'
export const DOMAIN = process.env.REACT_APP_DOMAIN
  ? process.env.REACT_APP_DOMAIN + '/'
  : process.env.NODE_ENV === 'development'
  ? 'http://localhost:3000/'
  : 'https://www.cricketbazaar.com/'
export const REACT_APP_ENV = process.env.REACT_APP_ENV || 'production'
export const BLUR_DATA_URL_BASE64 = '123'


export const SITE_NAME = 'Cricket Bazaar'
export const PUBLIC_GA_TRACKING_ID = 'G-74X1EMTVXY'
export const PUBLIC_GTM_ID = ''
export const ONLY_SPACE = /.*\S.*/
export const PLAY_STORE_URL = ''
export const APP_STORE_URL = ''
export const SB11_ONE_LINK_URL = 'https://sportsbuzz11.onelink.me/nOcv/hbgkb441'
export const SB_ONE_LINK_URL = 'https://sportsbuzz.onelink.me/gjvf/8aa6oqbi'

export const TOAST_TYPE = {
  Error: 'danger',
  Success: 'success'
}

export const CONTACT_EMAIL = 'contact@sportsbuzz.com'
export const CAREER_EMAIL = 'career@sportsbuzz.com'
export const DEFAULT_BLOG_READ = 2

// widget
export const WIDGET = {
  ranking: 'ranking',
  upcomingMatches: 'upcomingMatches',
  fantasyTips: 'fantasytips',
  trendingPlayers: 'trendingPlayers',
  trendingNews: 'trendingNews',
  prioritySeries: 'prioritySeries',
  topTeams: 'topTeams',
  trendingPlayer: 'trendingPlayer',
  didYouKnow: 'didYouKnow'
}

export const GENDERS = [
  { sLabel: 'Male', sValue: 'male' },
  { sLabel: 'Female', sValue: 'female' }
]

export const ROLES = [
  { sValue: 'All Rounder', sLabel: 'all' },
  { sValue: 'Batsman', sLabel: 'bat' },
  { sValue: 'Bowler', sLabel: 'bowl' },
  { sValue: 'Wicket Keeper', sLabel: 'wk' }
]

export const roles: any = {
  all: 'All',
  bat: 'Bat',
  bowl: 'Bowl',
  wk: 'Wk'
}

export const rolesFull: any = {
  all: 'AllRounder',
  bat: 'Batsman',
  bowl: 'Bowler',
  wk: 'Wicket Keeper'
}

export const getRun: any = {
  '1s': 1,
  '2s': 2,
  '3s': 3,
  '4s': 4,
  '6s': 6
}

export const formatType = {
  Test: 'test',
  Odi: 'odi',
  T20I: 't20i'
}

export const compareStatsTabs = [
  { name: 'Test', value: 'test' },
  { name: 'T20', value: 't20' },
  { name: 'T20i', value: 't20i' },
  { name: 'Odi', value: 'odi' },
  { name: 'List A', value: 'lista' },
  { name: 'FC', value: 'firstclass' }
]

export const battingStatsTab = [
  { name: 'Matches', value: 'nMatches' },
  { name: 'Innings', value: 'nInnings' },
  { name: 'Runs', value: 'nRuns' },
  { name: 'Balls Played', value: 'nBalls' },
  { name: 'Highest Score', value: 'nHighest' },
  { name: 'Not Outs', value: 'nNotOut' },
  { name: 'Strike Rate', value: 'sStrike' },
  { name: 'Average', value: 'sAverage' },
  { name: '50s', value: 'nRun50' },
  { name: '100s', value: 'nRun100' },
  { name: '4s', value: 'nRun4' },
  { name: '6s', value: 'nRun6' }
]

export const bowlingStatsTab = [
  { name: 'Matches', value: 'nMatches' },
  { name: 'Innings', value: 'nInnings' },
  { name: 'Overs', value: 'nOvers' },
  { name: 'Runs conceded', value: 'nRuns' },
  { name: 'Wickets', value: 'nWickets' },
  { name: 'Best Bowling Inning', value: 'sBestinning' },
  { name: 'Best Bowling Match', value: 'sBestmatch' },
  { name: 'Bowl avg.', value: 'sAverage' },
  { name: 'Economy', value: 'sEcon' },
  { name: 'Bowling SR', value: 'sStrike' },
  { name: '4 Wickets', value: 'nWicket4i' },
  { name: '5 Wickets', value: 'nWicket5i' }
]

export const DESIGNATION = [
  { label: 'Jr. Staff Writer', value: 'jsw' },
  { label: 'Sr. Staff Writer', value: 'ssw' },
  { label: 'Jr. Correspondent', value: 'jc' },
  { label: 'Sr. Correspondent', value: 'sc' },
  { label: 'Sub-Editor', value: 'se' },
  { label: 'Assistant Editor', value: 'ae' },
  { label: 'Editor', value: 'e' },
  { label: 'Sr. Editor', value: 'sre' },
  { label: 'Consulting Editor', value: 'ce' },
  { label: 'Editor-in-Chief', value: 'eic' },
  { label: 'Freelancer Writer', value: 'frw' },
  { label: 'Freelancer Correspondent', value: 'fc' },
  { label: 'Jr. Statistician', value: 'js' },
  { label: 'Sr. Statistician', value: 'ss' },
  { label: 'Guest Writer', value: 'gw' },
  { label: 'Columnist', value: 'c' },
  { label: 'Featured Writer', value: 'fw' },
  { label: 'Author', value: 'a' }
]

export const REVIVE_ID = '727bec5e09208690b050ccfc6a45d384'
